<script lang="jsx">
import { caseOf } from "../../lib";
import StoreForm from "../../components/StoreForm.js";
import storesMixin from "../../mixins/storesMixin.js";

export default {
  mixins: [storesMixin],

  created() {
    this.selectEmptyStore();
    this.setStoreProviders();
    this.setStoreCategories();
    this.clearWizardForm();
  },

  render() {
    return (
      <div class="page">
        <h2>
          Create Store
          {this.currentStep === 0 ? (
            <span>Step 1 / 3: Set store information</span>
          ) : this.currentStep === 1 ? (
            <span>Step 2 / 3: Set payment </span>
          ) : this.currentStep === 2 ? (
            <span>Step 3 / 3: Set visibility settings</span>
          ) : (
            <span />
          )}
        </h2>
        {caseOf(this.selectedStore, {
          Done: store => (
            <div>
              <StoreForm
                context={this}
                store={store}
                storeProviders={this.storeProviders}
                storeCategories={this.storeCategories}
                action={this.saveStore}
                isNewStore={true}
              />
            </div>
          ),
          _: () => (
            <div class="spinner-container">
              <div class="spinner" />
            </div>
          ),
        })}
      </div>
    );
  },
};
</script>
